class CoverageVariants extends HTMLElement {
  constructor() {
    super();
    this.styleCode = this.dataset.style;
    this.normalSwatchContainer = this.querySelector('[data-coverage-options]');
    this.query = `CoverageStyle:${this.styleCode}`;
    this.producJson = document.querySelector('[data-product-json]');
    this.productMainInfo = document.querySelector('.product-main__info');
    this.productHandle = this.dataset.productHandle
    this.init();
  }

  renderSwatches(data) {
    data.results.forEach((product, index, array) => {
      const swatch = document.createElement('div');
      swatch.classList.add('coverage-variants__link-wrapper');

      let coverage = null;

      product.coverage_name ? (coverage = product.coverage_name) : null;

      let order = null
      
      if (coverage) {
        if(coverage == "Moderate" || coverage == "moderate"){
          coverage = "Classic"
          order = "0"
        }else if(coverage.includes("Full") || coverage.includes("full")) {
          coverage = "Full"
          order = "1"
        }

        order ? swatch.classList.add('order-' + order) : null

        swatch.innerHTML = `
        <a href="${product.url}" class="coverage-link${product.handle == this.productHandle ? ' active' : ''}">
          ${coverage}
        </a>
        `;
        let isLimited = false;

        this.normalSwatchContainer.appendChild(swatch);
      }
    });
  }

  init() {
    fetch(`/search?type=product&q="${this.query}"&view=json-data`).then((response) => {
      response.json().then((data) => {
        this.renderSwatches(data);
      });
    });
  }
}

if (!customElements.get('coverage-variants')) {
  customElements.define('coverage-variants', CoverageVariants);
}
